import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ScrollText } from 'lucide-react';
import LanguageSwitcher from '../components/LanguageSwitcher';

const PageHeader = () => {
  const { t } = useTranslation();

  return (
    <header className="fixed top-0 w-full bg-white z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center flex-shrink-0">
          <img
            src="https://imgur.com/nYWIvWJ.png"
            alt="Nextcoders Logo"
            className="h-8"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/150x32/1f2937/ffffff?text=Nextcoders';
            }}
          />
        </Link>
        <div className="flex items-center gap-4">
          <LanguageSwitcher variant="compact" />
          <Link to="/nexbot-contact" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
            Contacto
          </Link>
          <Link to="/nexbot" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
            {t('nexbot.eula.header_links.nexbot')}
          </Link>
          <Link to="/nexbot-privacidad" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
            {t('nexbot.eula.header_links.privacy')}
          </Link>
        </div>
      </div>
    </header>
  );
};

const NexbotEulaPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sections = t('nexbot.eula.sections', { returnObjects: true });

  return (
    <div className="min-h-screen bg-white/60">
      <PageHeader />

      <main className="pt-32 pb-20 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <button
            type="button"
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/nexbot'))}
            className="inline-flex items-center gap-2 text-gray-600 hover:text-[#141414] mb-8 transition font-medium"
          >
            <ArrowLeft size={16} />
            {t('nexbot.eula.back')}
          </button>

          <div className="bg-white border border-gray-200 rounded-3xl p-8 md:p-12 shadow-sm">
            <div className="flex items-center gap-4 mb-8">
              <div className="p-3 bg-gray-100 text-[#141414] rounded-2xl">
                <ScrollText size={28} />
              </div>
              <div>
                <div className="text-sm font-semibold text-gray-500">{t('nexbot.eula.brand')}</div>
                <h1 className="text-3xl md:text-4xl font-bold text-[#141414]">
                  {t('nexbot.eula.title')}
                </h1>
              </div>
            </div>

            <div className="prose max-w-none text-gray-700 leading-relaxed">
              <p>
                <strong>{t('nexbot.eula.agreement_title')}</strong>
              </p>
              <p>
                <strong>{t('nexbot.eula.updated_label')}</strong> {t('nexbot.eula.updated_value')}
              </p>
              <p>{t('nexbot.eula.intro_1')}</p>
              <p>{t('nexbot.eula.intro_2')}</p>

              {sections.map((section) => (
                <section key={section.title} className="mt-8">
                  <h2 className="text-xl font-bold text-[#141414] mb-3">{section.title}</h2>
                  <p>{section.body}</p>
                </section>
              ))}

              <section className="mt-8">
                <h2 className="text-xl font-bold text-[#141414] mb-3">{t('nexbot.eula.contact_title')}</h2>
                <p>
                  {t('nexbot.eula.contact_prefix')}{' '}
                  <Link to="/nexbot-contact" className="text-blue-600 hover:underline font-medium">
                    /nexbot-contact
                  </Link>{' '}
                  <span className="text-gray-500">| apps@nextcoders.work</span>
                </p>
              </section>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200 flex flex-col sm:flex-row gap-4">
              <Link
                to="/nexbot"
                className="inline-flex justify-center px-6 py-3 bg-[#141414] text-white rounded-xl font-semibold hover:bg-gray-900 transition"
              >
                {t('nexbot.eula.back_to_nexbot')}
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NexbotEulaPage;
